import { G } from '@mobily/ts-belt';
import { GetClientCapabilitiesAndBusinessLineQuery } from '../../utils/hooks/getClientCapabilitiesAndBusinessLine';

/**
 * Based on what we received from the GetClientCapabilitiesAndBusinessLineQuery,
 * this function determines if the client is able to have the correct permissions
 * to access their wardrobe section.
 */
export const hasPermissions = (data?: GetClientCapabilitiesAndBusinessLineQuery) => !G.isUndefined(data) && G.isObject(data.client) && data.client.capabilities.canShop;